import React, { useState } from 'react'
import Button from '@material-ui/core/Button'
import { bindActionCreators } from 'redux'
import ReduxCallRecord from '../../../../store/actionreducers/callRecord'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

function CallRecordPlayer({ archiveId, fetchArchiveById }) {
    const [archiveUrl, setArchiveUrl] = useState('')

    if (archiveUrl === '') return <Button onClick={() =>
        fetchArchiveById({ archiveId })
            .then(({ archiveUrl }) => setArchiveUrl(archiveUrl))
    }>按此載入通話錄音</Button>

    return <audio controls src={archiveUrl} style={{ width: '100%' }}>您的瀏覽器不支援 HTML 5 播放器</audio>
}

const styles = () => ({
    root: {},
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchArchiveById: ReduxCallRecord.ActionCreator.fetchArchiveById,
    }, dispatch)
}

function mapStateToProps() {
    return {}
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CallRecordPlayer)))



// WEBPACK FOOTER //
// ./src/main/content/callHelper/callRecord/CallRecordPlayer.js